/**
 * 여러 favicon 서비스 URL들을 우선순위대로 반환하는 함수 (fallback용)
 * @param url - 대상 웹사이트 URL
 * @returns favicon URL 배열 (우선순위 순)
 */
export const getFaviconUrl = (url: string): string => {
  // URL에서 도메인 추출
  const getDomain = (inputUrl: string): string => {
    try {
      // 프로토콜이 없으면 https:// 추가
      // 이유: 1) Mixed Content 정책 (HTTPS 사이트에서 HTTP 리소스 차단)
      //      2) 현대 웹사이트 대부분이 HTTPS 지원
      //      3) 자동 HTTP fallback은 없음 - 필요시 별도 구현 필요
      const fullUrl = inputUrl.startsWith("http") ? inputUrl : `https://${inputUrl}`;

      const urlObj = new URL(fullUrl);

      return urlObj.hostname;
    } catch (error) {
      // URL 파싱 실패시 원본 반환
      return inputUrl;
    }
  };

  const domain = getDomain(url);

  const faviconUrl = `https://icons.duckduckgo.com/ip3/${domain}.ico`;

  return faviconUrl;
};
